import { render, staticRenderFns } from "./BmvTable.vue?vue&type=template&id=65ed205c&scoped=true"
import script from "./BmvTable.vue?vue&type=script&lang=js"
export * from "./BmvTable.vue?vue&type=script&lang=js"
import style0 from "./BmvTable.vue?vue&type=style&index=0&id=65ed205c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed205c",
  null
  
)

export default component.exports